import { initComponentStore, noop } from "@/utils/mobx";
import { ContextMenuStore } from "@/components/toolkit/ContextMenu/store";


export interface Tab {
    path: string;
    label: string;
    isVault?: boolean;
}

/**
 * Returns a new tab array with `path` added, evicting the oldest non-active
 * tab when the list would exceed `maxTabs`.  No-ops if path is already present.
 */
export function evictAndAddTab(openTabs: Tab[], path: string, maxTabs: number, isVault?: boolean): Tab[] {
    if (openTabs.some(t => t.path === path)) return openTabs;
    const filename = path.split("/").filter(Boolean).pop() ?? path;
    const label = isVault ? `vault:${filename}` : filename;
    const tab: Tab = isVault ? { path, label, isVault: true } : { path, label };
    // Vault tabs are exclusive: replace any existing vault tab (only one at a time).
    const base = isVault ? openTabs.filter(t => !t.isVault) : [...openTabs];
    const tabs = [...base, tab];
    if (tabs.length > maxTabs) {
        const evictIdx = tabs.findIndex(t => t.path !== path);
        if (evictIdx !== -1) tabs.splice(evictIdx, 1);
    }
    return tabs;
}

export class TabsStore {
    tabs: Tab[] = [];
    activeTabPath: string | null = null;
    onTabChange: (path: string) => any = noop;
    onTabClose: (path: string) => any = noop;
    onTabCloseAll: () => any = noop;
    onTabCloseOthers: (path: string) => any = noop;
    onTabReorder: (fromIndex: number, toIndex: number) => any = noop;
    contextMenuStore: ContextMenuStore = new ContextMenuStore();

    constructor() {
        initComponentStore(this, { contextMenuStore: false });
    }

    selectTab(path: string) {
        this.activeTabPath = path;
        this.onTabChange(path);
    }

    closeTab(path: string) {
        this.onTabClose(path);
    }
}
